import CharacterCounter from '@stimulus-components/character-counter';

// Connects to data-controller="custom-character-counter"
export default class extends CharacterCounter {
  connect() {
    super.connect?.();
    this.inputTarget.addEventListener('input', this.truncateIfNeeded);
  }

  disconnect() {
    this.inputTarget.removeEventListener('input', this.truncateIfNeeded);
    super.disconnect?.();
  }

  truncateIfNeeded = () => {
    let value = this.inputTarget.value;
    let max = this.inputTarget.maxLength;
    if (!max || max < 0) return;
    let count = 0;
    let result = '';

    for (let i = 0; i < value.length; i++) {
      count += value[i] === '\n' ? 2 : 1;
      if (count > max) break;
      result += value[i];
    }

    if (value !== result) {
      this.inputTarget.value = result;
      this.update();
    }
  };

  get count() {
    let value = this.inputTarget.value;
    let length = value.length + (value.match(/\n/g) || []).length;

    if (this.hasCountdownValue) {
      if (this.maxLength < 0) {
        console.error(
          `[stimulus-character-counter] You need to add a maxlength attribute on the input to use countdown mode. The current value is: ${this.maxLength}.`,
        );
      }
      length = Math.max(this.maxLength - length, 0);
    }

    return length;
  }
}
